import _ from "lodash";

export const DATA_LIMIT = 10;
export const SHOPIFY_PRODUCT_IMAGES_PATH = 'shopify-products-images';
export const SHOPIFY_COLLECTION_IMAGES_PATH = 'shopify-collections-images';

export const SHOPIFY_KEYS = {
    SELECTED_TAB: 'shopify.selected-tab',
};
export const SHOPIFY_DASHBOARD_TABS_LIST = [
    {
        key: 'products',
        label: 'Products'
    },
    {
        key: 'designs',
        label: 'Design Info'
    },
    {
        key: 'design-sync',
        label: 'Design Sync'
    },
    {
        key: 'pinterest-pin-sync',
        label: 'Pinterest Pin Sync'
    },
    {
        key: 'collections',
        label: 'Collections'
    },
    {
        key: 'instagram',
        label: 'Instagram'
    },
    {
        key: 'bulkProductUpdates',
        label: 'Bulk Product Updates'
    },
    {
        key: 'bulkOperations',
        label: 'Bulk Operations'
    },
    {
        key: 'blogs',
        label: 'Blogs'
    },
    {
        key: 'blog-posts',
        label: 'Blog Posts'
    },
    {
        key: 'productsPrice',
        label: 'Printful Products Price'
    },
    {
        key: 'productsPriceSync',
        label: 'Shopify Products Price Sync'
    },
    {
        key: 'media',
        label: 'Media'
    },
    /*{
        key: 'selected-products',
        label: 'Selected Products'
    },*/
];

export const DEFAULT_SHOPIFY_DASHBOARD_TAB = {
    key: 'products',
    label: 'Products'
};

export const SHOPIFY_PRODUCT_IMAGE_TABS_LIST = [
    {
        key: 'settings',
        label: 'Settings'
    },
    {
        key: 'instagram',
        label: 'Instagram'
    },
];

export const DEFAULT_SHOPIFY_PRODUCT_IMAGE_TAB = {
    key: 'settings',
    label: 'Settings'
}

export const SHOPIFY_PRODUCT_IMAGE_TYPE_TABS_LIST = [
    {
        key: 'squared',
        label: 'Squared (1:1)'
    },
    {
        key: 'vertical',
        label: 'Vertical (4:5)'
    },
    {
        key: 'original',
        label: 'Original (1:1)'
    },
    {
        key: 'original-vertical',
        label: 'Original (4:5)'
    },
];

export const DEFAULT_SHOPIFY_PRODUCT_IMAGE_TYPE_TAB = {
    key: 'squared',
    label: 'Squared'
};

export const SHOPIFY_PRODUCT_FIELDS_LIST = [
    {
        attribute: "id",
        label: "ID"
    },
    {
        attribute: "images",
        type: 'list',
        label: "Images"
    },
    {
        attribute: "title",
        label: "Title"
    },
    {
        attribute: "status",
        label: "Status"
    },
    /*{attribute: "vendor", label: "Vendor"},*/
    /* {attribute: "mediaCount", label: "Media Count"},
     {attribute: "totalVariants", label: "Total Variants"},
     {attribute: "options", type: 'list', label: "Options"},*/
    /*{attribute: "variants", type: 'list', label: "Variants"},
    {attribute: "collections", type: 'list', label: "Collections"},
    {attribute: "handle", label: "Handle"},
    {attribute: "onlineStoreUrl", label: "Online Store Url"},
    {attribute: "seo", type: 'object', label: "SEO"},
    {attribute: "productType", label: "Product Type"},*/
];

export const INSTAGRAM_IMAGE_SIZE_4_TO_5 = {
    width: 1000,
    height: 1250,
    position: 'left-top',
    containerClass: 'instagram-image-stage-container-4-to-5',
    cssWidth: 400,
    cssHeight: 500,
};
export const INSTAGRAM_IMAGE_SIZE_1_TO_1 = {
    width: 1000,
    height: 1000,
    position: 'left-top',
    containerClass: 'instagram-image-stage-container-1-to-1',
    cssWidth: 500,
    cssHeight: 500,
};
export const INSTAGRAM_IMAGE_SIZE_ORIGINAL = {
    width: 1000,
    height: 1000,
    position: 'left-top',
    containerClass: 'instagram-image-stage-container-1-to-1',
    cssWidth: 500,
    cssHeight: 500,
};
export const INSTAGRAM_IMAGE_SIZE_ORIGINAL_4_TO_5 = {
    width: 1000,
    height: 1250,
    position: 'left-top',
    containerClass: 'instagram-image-stage-container-4-to-5',
    cssWidth: 400,
    cssHeight: 500,
};
export const LOGO_IMAGE_DETAIL = {
    logo: {
        width: 408,
        height: 100,
        x: 20,
        y: 20
    }
};
export const PRODUCT_IMAGE_DETAIL = {
    product: {
        fit: "height",
        size: 100,
        fillPatternOffsetXPercentage: 0,
        fillPatternOffsetYPercentage: 0,
        fillPatternRotation: 0,
    }
};
export const DOWNLOAD_IMAGE_TIME_DELAY = 1000;
export const UPLOAD_IMAGE_TIME_DELAY = 500;
export const SAVE_PRODUCT_TIME_DELAY = 1000;

export const LOGO_POSITION_OPTIONS_LIST = [
    {
        key: 'left-top',
        label: 'Left Top'
    },
    {
        key: 'left-center',
        label: 'Left Center'
    },
    {
        key: 'left-bottom',
        label: 'Left Bottom'
    },
    {
        key: 'right-top',
        label: 'Right Top'
    },
    {
        key: 'right-center',
        label: 'Right Center'
    },
    {
        key: 'right-bottom',
        label: 'Right Bottom'
    },
    {
        key: 'center-top',
        label: 'Center Top'
    },
    {
        key: 'center-center',
        label: 'Center Center'
    },
    {
        key: 'center-bottom',
        label: 'Center Bottom'
    },
];

export const LOGO_FIELD_LIST = [
    {
        attribute: 'positionType',
        label: 'Logo Position',
        type: 'select',
        readOnly: false,
        group: 'position',
        options: LOGO_POSITION_OPTIONS_LIST,
        default: 'left-top',
    }
];

export const SHOPIFY_BULK_OPERATION_FIELDS_LIST = [
    {
        attribute: "dataType",
        label: "Data Type"
    },
    {
        attribute: "nodeType",
        label: "Node Type"
    },
    {
        attribute: "objectCount",
        label: "Object Count"
    },
    {
        attribute: "status",
        label: "Status"
    },
    {
        attribute: "createdAt",
        label: "Created At"
    },
    {
        attribute: "completedAt",
        label: "Completed At"
    },
    {
        attribute: "dataFileName",
        label: "Data File Name"
    },
    {
        attribute: "fileSize",
        label: "File Size"
    },
    {
        attribute: "errorCode",
        label: "Error Code"
    },
];

export const SHOPIFY_BULK_PRODUCT_UPDATE_FIELDS_LIST = [
    {
        attribute: "id",
        label: "ID"
    },
    {
        attribute: "status",
        label: "Status"
    },
    {
        attribute: "total",
        label: "Total Products"
    },
    {
        attribute: "createdAt",
        label: "Created At"
    },
    {
        attribute: "completedAt",
        label: "Completed At"
    },
];

export const SHOPIFY_BLOG_FIELDS_LIST = [
    {
        attribute: "id",
        label: "ID",
        cssClass: 'text-center'
    },
    {
        attribute: "title",
        label: "Title"
    },
    {
        attribute: "handle",
        label: "Handle"
    },
    {
        attribute: "type",
        label: "Type"
    },
    {
        attribute: "created_at",
        label: "Created At"
    },
];

export const SHOPIFY_COLLECTION_FIELDS_LIST = [
    /*{attribute: "id", label: "ID", cssClass: 'text-center'},*/
    {
        attribute: "title",
        label: "Collection Details",
        cssClass: 'text-left'
    },
    /*{attribute: "handle", label: "Handle"},*/
    /*{attribute: "productsCount", label: "Products Count", cssClass: 'text-center'},*/
];

export const FIT_TYPE_LIST = [
    {
        key: 'height',
        label: 'Height'
    },
    {
        key: 'width',
        label: 'Width'
    },
];

export const PRODUCT_IMAGE_FIELD_LIST = [
    {
        attribute: 'fit',
        label: 'Fit',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: FIT_TYPE_LIST,
        default: "height"
    },
    {
        attribute: 'fillPatternRotation',
        label: 'Fill Pattern Rotation',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    /*{attribute: 'size', label: 'Size (%)', type: 'number', readOnly: false, group: 'dimension', default: "100"},*/
    {
        attribute: 'fillPatternOffsetXPercentage',
        label: 'Fill Pattern Offset X (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternOffsetYPercentage',
        label: 'Fill Pattern Offset Y (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
];

export const INSTAGRAM_POST_SCHEDULE_LIST = [
    {
        key: '7 AM',
        label: '7 AM'
    },
    {
        key: '8 AM',
        label: '8 AM'
    },
    {
        key: '9 AM',
        label: '9 AM'
    },
    {
        key: '10 AM',
        label: '10 AM'
    },
    {
        key: '11 AM',
        label: '11 AM'
    },
    {
        key: '12 PM',
        label: '12 PM'
    },
    {
        key: '1 PM',
        label: '1 PM'
    },
    {
        key: '2 PM',
        label: '2 PM'
    },
    {
        key: '3 PM',
        label: '3 PM'
    },
    {
        key: '4 PM',
        label: '4 PM'
    },
    {
        key: '5 PM',
        label: '5 PM'
    },
    {
        key: '6 PM',
        label: '6 PM'
    },
    {
        key: '7 PM',
        label: '7 PM'
    },
    {
        key: '8 PM',
        label: '8 PM'
    },
    {
        key: '9 PM',
        label: '9 PM'
    },
];

export const INSTAGRAM_POST_SCHEDULE_MAP = _.keyBy(INSTAGRAM_POST_SCHEDULE_LIST, 'key');

export const POST_FREQUENCY = [
    {
        key: 'same-day-time',
        label: 'Same Day & Time'
    },
    {
        key: 'same-day-every-time',
        label: 'Same Day & Every Time'
    },
    {
        key: 'every-day-same-time',
        label: 'Every Day & Same Time'
    },
    {
        key: 'every-day-time',
        label: 'Every Day & Time'
    },
];

export const BULK_INSTAGRAM_POST_FIELDS = [
    {
        attribute: 'postFrequency',
        label: 'Post Frequency',
        type: 'select',
        readOnly: false,
        group: 'schedule',
        options: POST_FREQUENCY,
        default: 'every-day-same-time',
    },
    {
        attribute: 'postDate',
        label: 'Post Start Date',
        type: 'date',
        readOnly: false,
        group: 'schedule'
    },
    {
        attribute: 'postTime',
        label: 'Post Time',
        type: 'select',
        readOnly: false,
        group: 'schedule',
        options: INSTAGRAM_POST_SCHEDULE_LIST,
        default: '',
    }
];

export const INSTAGRAM_POST_FIELDS = [
    {
        attribute: 'postDate',
        label: 'Post Date',
        type: 'date',
        readOnly: false,
        group: 'schedule'
    },
    {
        attribute: 'postTime',
        label: 'Post Time',
        type: 'select',
        readOnly: false,
        group: 'schedule',
        options: INSTAGRAM_POST_SCHEDULE_LIST,
        default: '',
    }
];

export const INSTAGRAM_POST_STATUS_LIST = [
    {
        key: 'Published',
        label: 'Published'
    },
    {
        key: 'Scheduled',
        label: 'Scheduled'
    },
    {
        key: 'EMPTY',
        label: 'Not Scheduled'
    },
];

export const INSTAGRAM_POST_FILTER_FIELDS = [
    {
        attribute: 'title',
        label: 'Title',
        type: 'text',
        readOnly: false,
        group: 'schedule'
    },
    {
        attribute: 'postDate',
        label: 'Post Date',
        type: 'date',
        readOnly: false,
        group: 'schedule'
    },
    {
        attribute: 'status',
        label: 'Post Status',
        type: 'select',
        readOnly: false,
        group: 'schedule',
        options: INSTAGRAM_POST_STATUS_LIST,
        default: '',
    },
    {
        attribute: 'imagesUploaded',
        label: 'Images Uploaded',
        type: 'checkbox',
        readOnly: false,
        group: 'schedule'
    }
];

export const PRODUCT_SEO_FIELD_LIST = [
    {
        attribute: 'title',
        label: 'Title',
        type: 'text',
        group: 'seo'
    },
    {
        attribute: 'description',
        label: 'Description',
        type: 'text-area',
        hideInList: true,
        group: 'seo',
        rows: 3
    },
];

export const PRODUCT_FIELD_LIST = [
    {
        attribute: 'descriptionHtml',
        label: 'Description HTML',
        type: 'text-area',
        hideInList: true,
        group: 'product',
        rows: 5
    },
];

export const SHOPIFY_BULK_PRODUCT_UPDATE_TABS_LIST = [
    /*{key: 'tags', label: 'Tags'},
    {key: 'meta-description', label: 'Meta Description'},*/
    {
        key: 'bulk-update-fields',
        label: 'Bulk Update Fields'
    },
];

export const DEFAULT_SHOPIFY_BULK_PRODUCT_UPDATE_TAB = {
    key: 'bulk-update-fields',
    label: 'Bulk Update Fields'
};
